module.exports = __webpack_public_path__ + "static/media/5DPO21.6159bf79.jpg";